<template>
  <b-container>
    <b-row class="my-1" v-if="$route.params.msg">
      <b-col>
        <b-alert
          :show="dismissCountDown"
          dismissible
          variant="success"
          class="text-center"
          @dismissed="dismissCountDown = 0"
        >{{ $route.params.msg }}</b-alert>
      </b-col>
    </b-row>
    <div style="margin-bottom: 0.5em;" class="text-right" v-if="filterTags.length">
      <b-button variant="outline-danger" size="sm" @click="showFilterModal">
        <font-awesome-icon icon="filter" />
        {{$t('Categories.filterButton')}}
      </b-button>
    </div>
    <b-jumbotron v-show="filterTagsSelected.length > 0 && categories.length <= 0">
      <p>
        <i>{{ $t('Categories.noFilterMatchMsg') }}</i>
      </p>
      <b-button variant="danger" @click="clearFilter">{{ $t('Categories.clearFilter') }}</b-button>
    </b-jumbotron>
    <div role="tablist" v-if="categories.length > 0">
      <div v-for="(category, i) in categories" :key="i">
        <!-- Fill initial accordion menu with top categories -->
        <b-card
          no-body
          class="mb-1"
          v-if="!category.parent && category.hidden !== true"
          :header="categoryName(category._id)"
          header-bg-variant="danger"
          header-text-variant="white"
        >
          <!-- Fill menu with corresponding sub-categories -->
          <div role="tablist" v-if="category.children">
            <b-card
              no-body
              v-for="(subCategoryId, j) in category.children"
              :key="j"
              :header="categoryName(subCategoryId)"
            >
              <div v-for="(item, k) in items" :key="k">
                <!-- Loop through items in corresponding sub-category -->
                <b-card-body v-if="item.category === subCategoryId">
                  <item v-if="item.hidden !== 'true'" :menuitem="item" :filterTags="filterTags"></item>
                </b-card-body>
              </div>
            </b-card>
          </div>
          <!-- Loop through items in corresponding category -->
          <div v-for="(item, k) in items" :key="k">
            <b-card-body v-if="item.category === category._id">
              <item v-if="item.hidden !== 'true'" :menuitem="item" :filterTags="filterTags"></item>
            </b-card-body>
          </div>
        </b-card>
      </div>
    </div>
    <!-- Modal Component -->
    <b-modal
      v-model="modalShow"
      @ok="filterMenu"
      ok-variant="danger"
      :ok-title="$t('Categories.ftOK')"
      :cancel-title="$t('Categories.ftCancel')"
      hide-header
      @cancel="filterTagsSelected = filterTagsSelectedAtModalOpen"
    >
      <h5>{{$t('Categories.ftTitle')}}</h5>
      <b-form-checkbox-group v-model="filterTagsSelected" :options="filterTags"></b-form-checkbox-group>
      <span class="clear-filter" @click="clearFilter">{{$t('Categories.clearFilter')}}</span>
    </b-modal>
  </b-container>
</template>

<script>
/* CONTROLLER */
import CategoriesService from '@/services/CategoriesService'
import FilterTagsService from '@/services/FilterTagsService'
import Item from '@/components/Item'
import HelperFunctions from '@/extras/HelperFunctions'
import { mapGetters } from 'vuex'

export default {
  name: 'Categories',
  components: {
    Item
  },
  data () {
    return {
      unfilteredCategories: [],
      categories: [],
      unfilteredItems: [],
      items: [],
      selected: '',
      dismissCountDown: 10,
      modalShow: false,
      filterTags: [],
      filterTagsSelected: [],
      filterTagsSelectedAtModalOpen: [],
      unfilteredFilterTags: []
    }
  },
  mounted () {
    // redirect to home if no stripeConnectUserId or no table number set
    if (!this.stripeConnectUserId || !this.tableNumber) {
      this.$router.push({ name: 'Home' })
    }
    this.getCategories()
    this.fetchFilterTags()
  },
  methods: {
    async getCategories () {
      const response = await CategoriesService.getCategories()
      this.unfilteredCategories = response.data.categories
      this.filterCategories()

      // populate menu items
      for (const category of this.categories) {
        await this.getItems(category._id)
      }

      // Fill filter tags
      this.fillFilterTags()
    },
    async getItems (category) {
      // check if category is already in the items array
      // and add only if it isn't
      let checkItems = this.unfilteredItems.filter(i => {
        return i.category === category
      })
      if (typeof checkItems[0] === 'undefined') {
        const response = await CategoriesService.getCategoryItems(category)

        // add to items array
        if (response.data.items.length > 0) {
          response.data.items.forEach(item => {
            this.unfilteredItems.push(item)
          })
        }

        this.filterItems()
      }
    },
    async fetchFilterTags () {
      // get all fetchFilterTags
      try {
        const response = await FilterTagsService.getFilterTags()
        this.unfilteredFilterTags = response.data.filtertags
      } catch (error) {
        console.log(error)
      }
    },
    fillFilterTags () {
      // erase filerTags and filterTagsSelected arrays, so there aren't lang duplicates
      this.filterTags = []
      this.filterTagsSelected = []

      let tempTags = []
      // get all the item filter tags
      this.items.forEach(i => {
        if (i.tags.length > 0) {
          i.tags.forEach(t => {
            // check if it aleady exists in temptags
            if (!tempTags.includes(t)) {
              tempTags.push(t)
            }
          })
        }
      })

      // match tempTags against all
      // and run through lang function
      tempTags.forEach(tt => {
        this.unfilteredFilterTags.forEach(ut => {
          if (tt === ut._id) {
            this.filterTags.push({
              text: this.filterItemLang(ut.name),
              value: ut._id
            })
          }
        })
      })
    },
    filterCategories () {
      // clear out categories array if not empty
      if (this.categories.length > 0) {
        this.categories = []
      }

      // filter based on current language
      // and assign to categories
      this.unfilteredCategories.forEach(category => {
        let localeCategory = {
          _id: category._id,
          title: category.title.filter(t => {
            return t.lang === this.$i18n.locale
          }),
          parent: category.parent || null,
          children: category.children || [],
          hidden: category.hidden,
          placeNumber: category.hidden || null
        }
        this.categories.push(localeCategory)
      })
    },
    filterItems () {
      // clear out items array if not empty
      if (this.items.length > 0) {
        this.items = []
      }

      // only execute if unfilteredItems array exists
      if (this.unfilteredItems.length > 0) {
        // filter based on current language
        // and assign to categories
        this.unfilteredItems.forEach(item => {
          let localeItem = {
            _id: item._id,
            currency: item.currency,
            category: item.category,
            image: item.image,
            hidden: item.hidden,
            placeNumber: item.placeNumber,
            price: item.price,
            name: this.filterItemLang(item.name),
            description: null,
            styles: [],
            tags: item.tags,
            extras: [],
            variants: []
          }

          if (item.description.length > 0) {
            localeItem.description = this.filterItemLang(item.description)
          }

          if (item.styles.length > 0) {
            // build styles
            item.styles.forEach(s => {
              // assign the first values array in case locale can't be found
              let localeItemStyle = {
                name: this.filterItemLang(s.name),
                _id: s._id
              }
              localeItem.styles.push(localeItemStyle)
            })
          }

          if (item.extras.length > 0) {
            // build extras
            item.extras.forEach(e => {
              let localeItemExtra = {
                name: this.filterItemLang(e.name),
                price: e.price,
                _id: e._id
              }
              localeItem.extras.push(localeItemExtra)
            })
          }

          if (item.variants.length > 0) {
            // build variants
            item.variants.forEach(v => {
              let localeItemVariant = {
                name: this.filterItemLang(v.name),
                price: v.price,
                _id: v._id
              }
              localeItem.variants.push(localeItemVariant)
            })
          }
          // finally, add to items array
          this.items.push(localeItem)
        })
      }
    },
    filterMenu () {
      // re-populate categories/items in case some were already filtered
      this.filterCategories()
      this.filterItems()

      // run only if there's a selected filter tag
      if (this.filterTagsSelected.length > 0) {
        // run filterTagsSelected against items
        let tempItems = []
        this.items.forEach(i => {
          if (
            HelperFunctions.allElementsExistInArray(
              i.tags,
              this.filterTagsSelected
            )
          ) {
            if (!tempItems.includes(i)) tempItems.push(i)
          }
        })

        // filter categories against what's listed in tempItems
        let tempCategories = []
        tempItems.forEach(ti =>
          Array.prototype.push.apply(
            tempCategories,
            this.categories.filter(c => c._id === ti.category)
          )
        )
        tempCategories = [...new Set(tempCategories)] // take out any duplicates

        // update categories & items array accordingly
        this.categories = tempCategories
        this.items = tempItems
      }
    },
    showFilterModal () {
      this.modalShow = true
      this.filterTagsSelectedAtModalOpen = this.filterTagsSelected
    },
    clearFilter () {
      this.filterTagsSelected = []
      this.modalShow = false
      this.filterMenu()
    },
    categoryName (id) {
      return this.filterLang(
        this.unfilteredCategories.filter(c => {
          return c._id === id
        })[0]
      )
    },
    filterLang (category) {
      // filter for selected language
      let text = category.title.filter(t => {
        return t.lang === this.$i18n.locale
      })
      // if text value undefined, filter for and assing a defined value
      return text.length > 0
        ? text[0].value
        : category.title.filter(t => {
          return t.value.length > 0
        })[0].value
    },
    filterItemLang (itemMember) {
      let itemFilter = itemMember.filter(i => {
        return i.lang === this.$i18n.locale
      })
      return itemFilter.length > 0
        ? itemFilter[0].value
        : itemMember.filter(i => {
          return i.value.length > 0
        })[0].value
    }
  },
  computed: {
    ...mapGetters({
      stripeConnectUserId: 'stripeConnectUserId',
      tableNumber: 'tableNumber'
    })
  },
  watch: {
    '$i18n.locale': {
      handler: function () {
        this.filterCategories()
        if (this.unfilteredItems.length > 0) {
          this.filterItems()
          this.fillFilterTags()
        }
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 0.25rem;
}
span.clear-filter {
  display: block;
  float: right;
  cursor: pointer;
  color: #dc3545;
}
@media only screen and (max-width: 600px) {
  .container {
    padding: 0.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Categories.vue